export default __webpack_public_path__ + "static/media/chigo-screenshot-02.cf3adc1f.png";